import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard';
import { AccessDeniedComponent, NotFoundComponent } from './shared';
import {
    aktyRoute, documentRoute,
    filtryRoute,
    formularzeDocumentoRoute, grafikiRoute,
    listyKontrolneRoute,
    orzeczeniaRoute,
    pismaUrzedoweRoute, proceduryRoute, publikacjeRoute, pytaniaOdpowiedziRoute, wzoryRoute,
    szkoleniaRoute, analizyRoute, documentForIdRoute, wazneTerminyRoute
} from './app.routing.consts';
import { ExternalLinkGuardCanActivate } from './external-link/external-link-guard';
import {ObiektIdLinkGuardCanActivate} from "./internal-link/obiekt-id-link-guard";

const appRoutes: Routes = [
    {path: '', redirectTo: filtryRoute, pathMatch: 'full'},
    {path: DashboardComponent.route, component: DashboardComponent},
    {path: AccessDeniedComponent.route, component: AccessDeniedComponent},
    {path: NotFoundComponent.route, component: NotFoundComponent},
    {path: documentRoute, component: NotFoundComponent, canActivate:  [ExternalLinkGuardCanActivate]},
    {path: documentForIdRoute, component: NotFoundComponent, canActivate:  [ObiektIdLinkGuardCanActivate]},
    {
        path: listyKontrolneRoute,
        loadChildren: () => import('./listy-kontrolne/lista-kontrolna.module').then(m => m.ListaKontrolnaModule)
    },
    {
        path: aktyRoute,
        loadChildren: () => import('./akty/akt.module').then(m => m.AktModule)
    },
    {
        path: pismaUrzedoweRoute,
        loadChildren: () => import('./pisma-urzedowe/pismo-urzedowe.module').then(m => m.PismoUrzedoweModule)
    },
    {
        path: filtryRoute,
        loadChildren: () => import('./filter/filter.module').then(m => m.FilterModule)
    },
    {
        path: orzeczeniaRoute,
        loadChildren: () => import('./orzeczenia/orzeczenie.module').then(m => m.OrzeczenieModule)
    },
    {
        path: formularzeDocumentoRoute,
        loadChildren: () => import('./formularze-documento/formularz-documento.module').then(m => m.FormularzDocumentoModule)
    },
    {
        path: pytaniaOdpowiedziRoute,
        loadChildren: () => import('./pytania-odpowiedzi/pytanie-odpowiedz.module').then(m => m.PytanieOdpowiedzModule)
    },
    {
        path: publikacjeRoute,
        loadChildren: () => import('./publikacje/publikacja.module').then(m => m.PublikacjaModule)
    },
    {
        path: proceduryRoute,
        loadChildren: () => import('./procedury/procedura.module').then(m => m.ProceduraModule)
    },
    {
        path: wzoryRoute,
        loadChildren: () => import('./wzory/wzor.module').then(m => m.WzorModule)
    },
    {
        path: grafikiRoute,
        loadChildren: () => import('./grafiki/grafika.module').then(m => m.GrafikaModule)
    },
    {
        path: szkoleniaRoute,
        loadChildren: () => import('./szkolenia/szkolenie.module').then(m => m.SzkolenieModule)
    },
    {
        path: analizyRoute,
        loadChildren: () => import('./analizy/analiza.module').then(m => m.AnalizaModule)
    },
    {
        path: wazneTerminyRoute,
        loadChildren: () => import('./wazne-terminy/wazny-termin.module').then(m => m.WaznyTerminModule)
    },
    {
        path: 'demo',
        loadChildren: () => import('./demo/demo.module').then(m => m.DemoModule)
    }
];

export const routing = RouterModule.forRoot(appRoutes, {
    // initialNavigation - wbudowana property wykorzystywana do opóźniania ładowania routingu
    // https://stackoverflow.com/questions/41036858/angular-2-delay-rendering-of-router-outlet
    // aby wyzwolic ładowanie wykorzystujemy this.router.initialNavigation();
    // Jest wykorzystywane aby załadować użytkownika, zanim będzie załadowany jakikolwiek widok w aplikacji
    initialNavigation: 'disabled'
});